<template>
  <div class="home-hero-sub row">
    <Left/>
    <Right/>
  </div>
</template>

<script>
import Right from './Right'
import Left from './Left'

export default {
  name: 'index',
  components: {
    Right,
    Left
  }
}
</script>

<style>
.home-hero-sub {
  margin-top: 14px;
}
.row{
  margin-left: -14px;
}
</style>